import { isFinanceVertical, isIndividual, isSalesVertical } from '@rma/common-ui-domain/helpers';
import { VerticalType, type ProfileType } from '@rma/common-ui-domain/types';
import {
  CAMPAIGN_ACTIVE_PARAM,
  CAMPAIGN_CODE_PARAM,
  ENQUIRY_TYPE_PARAM,
  EnquiryType,
  ProfileContactFormParams,
  TRIXEL_SOURCE_CATEGORY_PARAM,
  type ContactType,
  type ProfileContactAnalytics,
} from '@rma/profiles/public/domain';

export const getContactAnalyticsType = (verticalType: VerticalType, profileType: ProfileType): ContactType => {
  if (isSalesVertical(verticalType) && isIndividual(profileType)) {
    return 'Agent';
  }

  if (isFinanceVertical(verticalType)) {
    return 'Mortgagebroker';
  }

  return 'Agency';
};

export const getProfileContactAnalytics = (
  verticalType: VerticalType,
  profileCode: string,
  profileType: ProfileType,
  isMobilePhone: boolean,
  sourceCategoryTwo?: string,
): ProfileContactAnalytics => {
  const contactType = getContactAnalyticsType(verticalType, profileType);

  const categoryTwo = sourceCategoryTwo !== undefined ? sourceCategoryTwo : `${contactType}Profile`;

  return {
    contactType,

    analyticsActionRevealPhone: `${contactType} Profile Phone numbers Viewed`,
    analyticsLabelRevealPhone: `${contactType} ${profileCode}`,
    trixelsRevealPhoneCategory: `RateMyAgent-${categoryTwo}-Reveal`,

    analyticsActionCallMade: `${contactType} Profile Phone Called`,
    analyticsLabelCallMade: `${isMobilePhone ? 'Mobile' : 'Landline'} - ${contactType} ${profileCode}`,
    trixelsCallMadeCategory: `RateMyAgent-${categoryTwo}-Call`,

    analyticsActionSmsMade: `${contactType} Profile SMS Opened`,
    analyticsLabelSmsMade: `SMS - ${contactType} ${profileCode}`,
    trixelsSmsMadeCategory: `RateMyAgent-${categoryTwo}-Sms`,
  };
};

export const getContactUrlParams = (params: {
  trixelSourceCategory: string;
  enquiryType?: EnquiryType;
  campaignCode?: string;
  campaignActive?: boolean;
}): ProfileContactFormParams => {
  let contactUrlParams: ProfileContactFormParams = {
    [TRIXEL_SOURCE_CATEGORY_PARAM]: params.trixelSourceCategory,
  };

  const { enquiryType, campaignCode, campaignActive } = params;

  if (enquiryType) {
    contactUrlParams = { ...contactUrlParams, [ENQUIRY_TYPE_PARAM]: enquiryType };
  }

  if (campaignCode) {
    contactUrlParams = { ...contactUrlParams, [CAMPAIGN_CODE_PARAM]: campaignCode };
  }

  if (campaignActive !== undefined) {
    contactUrlParams = { ...contactUrlParams, [CAMPAIGN_ACTIVE_PARAM]: campaignActive };
  }

  return contactUrlParams;
};
